import React from "react";
import { styled } from "../../stitches.config";

import Link from "../Link";

import Cytat from "../../assets/img/natemat/quote.svg";
import Dwukropek from "../../assets/img/natemat/kulki.png";
import CommentImage from "../../assets/img/comment_white.svg";
import FacebookImage from "../../assets/img/facebook_round_white.svg";

const Quote = props => {
  const { article } = props;

  var imgUrl = article.author.img;
  imgUrl = imgUrl.replace("780,0,0,0", "55,55,1,0");

  return (
    <BoxWrapper>
      <ImageWrapper>
        <img alt="" src={imgUrl} />
      </ImageWrapper>

      {article.author.name
        ? <Author>{article.author.name}
          <span>:</span>
        </Author>
        : null}

      <Link to={article.url}>
        <Title>{article.title}</Title>
        <Intro>{article.intro}</Intro>
      </Link>
    </BoxWrapper>
  );
};

const BoxWrapper = styled("div", {
  padding: "12px 0",
  "> a": {
    color: "#000",
    "&:hover": {
      textDecoration: "none",
      cursor: "pointer",
      color: "$primary"
    }
  }
});

const ImageWrapper = styled("div", {
  display: "block",
  position: "relative",
  "&:after": {
    content: "",
    background: `url("${Cytat}") no-repeat center center`,
    backgroundSize: "cover",
    display: "block",
    height: "25px",
    width: "48px",
    position: "absolute",
    top: "10px",
    right: "5px"
  },
  "img": {
    display: "inline-block",
    borderRadius: "100%",
    marginBottom: "13px",
    height: "55px",
    width: "55px"
  }
});

const Author = styled("div", {
  fontSize: "13px",
  paddingBottom: "14px",
  span: {
    fontWeight: 500,
    color: "$primary"
  }
});

const Title = styled("div", {
  fontSize: "20px",
  paddingBottom: "8px"
});
const Intro = styled("div", {
  lineHeight: "21px",
  fontSize: "16px",
  fontFamily: '"Playfair Display", serif'
});

export default Quote;
